/**
 * Brazilian Portuguese strings for the `about` namespace — the "Sobre" page (what the codex
 * is, who makes it, data sources, legal, contact).
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 * `<s>`/`<i>` tags are mapped to elements by react-i18next's <Trans>.
 */
export const about = {
  breadcrumbCurrent: 'sobre',
  kicker: 'O códice por trás do códice',
  title: 'Sobre o RuneLedger',
  whatIs: {
    heading: 'O que é o projeto',
    p1: 'O <s>RuneLedger</s> é um projeto de fãs, feito no Brasil, que reúne num só lugar o que a comunidade de <i>RuneScape</i> consulta todo dia: perfis e habilidades de jogadores e os streamers brasileiros que mantêm Gielinor viva em português.',
    p2: 'Não vendemos nada, não temos anúncios e não pedimos senha de ninguém — <s>nunca compartilhe sua senha do jogo com sites de terceiros</s>.',
  },
  whoMakes: {
    heading: 'Quem faz',
    title: 'Forjado por G itbash',
    text: 'Aventureiro de Gielinor desde 2010 e desenvolvedor sênior no mundo real — o nick não deixa negar. O RuneLedger é o que acontece quando os dois ofícios batem o mesmo martelo: um códice à altura de Gielinor, forjado nas horas entre um chefe e outro. Contribuições, correções e ideias são bem-vindas no Discord.',
  },
  dataSources: {
    heading: 'De onde vêm os dados',
    profiles: {
      label: 'Perfis e skills',
      text: 'Hiscores e RuneMetrics oficiais da Jagex, consultados na hora da busca e guardados como snapshots para o histórico de XP.',
    },
    streamers: {
      label: 'Streamers',
      text: 'API da Twitch (categorias RuneScape e Old School RuneScape), filtrada pela lista curada de criadores brasileiros mantida pela comunidade.',
    },
    demoNote: 'Nesta versão de demonstração, todos os dados exibidos são fictícios.',
  },
  legal: {
    heading: 'Aviso legal',
    body: 'O RuneLedger é um projeto de fãs <s>sem qualquer afiliação, endosso ou vínculo com a Jagex Ltd</s>. RuneScape, Old School RuneScape e Gielinor são marcas registradas da Jagex Ltd. Todos os nomes de itens, habilidades e elementos do jogo pertencem aos seus respectivos donos e são usados aqui apenas para fins informativos, dentro das diretrizes de conteúdo de fãs da Jagex.',
  },
  cta: {
    title: 'Fale com o RuneLedger',
    text: 'Achou um erro, quer entrar pra lista de streamers ou tem uma ideia? A taverna fica no Discord.',
    discord: 'Discord do RuneLedger',
    email: 'E-mail',
  },
}
